import http from '@/utils/http'

let platformUserPermissionCache = null
let platformUserPermissionPromise = null
let platformUserPermissionToken = ''

async function getPlatformUserPermission() {
  const token = localStorage.getItem('token') || ''
  if (platformUserPermissionToken !== token) {
    platformUserPermissionCache = null
    platformUserPermissionPromise = null
    platformUserPermissionToken = token
  }
  if (platformUserPermissionCache) return platformUserPermissionCache
  if (!platformUserPermissionPromise) {
    platformUserPermissionPromise = http.post('/console/describeUserDetail')
      .then(({ data: { data, code } }) => {
        return code == 200 ? resolveTeamPermission(data || {}) : {}
      })
      .then((info) => {
        platformUserPermissionCache = info
        return info
      })
      .catch(() => ({}))
      .finally(() => {
        platformUserPermissionPromise = null
      })
  }
  return platformUserPermissionPromise
}

async function resolveTeamPermission(info) {
  if (info.is_group == 1 || !info.join_group_user_name) return info
  try {
    const {
      data: { data, code },
    } = await http.post('/console/userGroup/getSetting', {
      admin_group_username: info.join_group_user_name
    })
    if (code == 200 && data) {
      return {
        ...info,
        show_group_members: data.show_group_members
      }
    }
  } catch (e) {
    return info
  }
  return info
}

function isTeamAdmin(info) {
  return info && info.is_group == 1
}

function canViewTeamMembers(info) {
  const admin = isTeamAdmin(info)
  const isInTeam = admin || !!(info && info.join_group_user_name)
  return admin || (isInTeam && info.show_group_members == 1)
}

function isAgent(info) {
  return info && info.is_agent == 1
}

function teamPermissionGuard(type) {
  return async (to, from, next) => {
    const info = await getPlatformUserPermission()
    if (type === 'members' && canViewTeamMembers(info)) {
      next()
      return
    }
    if (type === 'admin' && isTeamAdmin(info)) {
      next()
      return
    }
    if (type === 'admin' && canViewTeamMembers(info)) {
      next({ name: 'platform_team_members', replace: true })
      return
    }
    next({ name: 'platform_creator', replace: true })
  }
}

function agentPermissionGuard(to, from, next) {
  getPlatformUserPermission().then((info) => {
    if (isAgent(info)) {
      next()
      return
    }
    next({ name: 'platform_creator', replace: true })
  })
}

const platformRouter = [
{
  path: '/console/platform',
  name: 'platform',
  redirect: { name: 'platform_creator' },
  meta: {
    title: '九马AI数字人智能创作平台',
    auth: true,
    menu: 'platform'
  },
  component: () => import('@/platform/pages/platform'),
  children: [
    {
      path: 'tools',
      name: 'platform_tools',
      redirect: { name: 'platform_tools_recordings' },
      meta: { title: '工具', auth: true, menu: 'platform', hideTaskSidebar: true },
      component: () => import('@/platform/pages/ToolsPanel/ToolsPanel.vue'),
      children: [
        {
          path: 'recordings',
          name: 'platform_tools_recordings',
          meta: { title: '录制任务列表', auth: true, menu: 'platform' },
          component: () => import('@/platform/pages/ToolsPanel/Recordings.vue'),
        },
        {
          path: 'recording-rooms',
          name: 'platform_tools_recording_rooms',
          meta: { title: '录制直播间列表', auth: true, menu: 'platform' },
          component: () => import('@/platform/pages/ToolsPanel/RecordingRooms.vue'),
        },
        {
          path: 'video-extract',
          name: 'platform_tools_video_extract',
          meta: { title: '短视频提取', auth: true, menu: 'platform' },
          component: () => import('@/platform/pages/ToolsPanel/VideoExtract.vue'),
        },
      ],
    },
    {
      path: 'creator',
      name: 'platform_creator',
      meta: {
        title: '创作工作台',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/CreatorPanel/CreatorPanel.vue'),
    },
    {
      path: 'digital',
      name: 'platform_digital',
      meta: {
        title: '数字人广场',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/DigitalPanel/DigitalPanel.vue'),
    },
    {
      path: 'action-simulation',
      name: 'platform_action_simulation',
      meta: {
        title: '动作模仿',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/ActionSimulationPanel/ActionSimulationPanel.vue'),
    },
    {
      path: 'voice-clone',
      name: 'platform_voice_clone',
      meta: {
        title: '配音列表',
        auth: true,
        menu: 'platform',
        hideTaskSidebar: true
      },
      component: () => import('@/platform/pages/VoiceClonePanel/VoiceClonePanel.vue'),
    },
    {
      path: 'projects',
      name: 'platform_projects',
      meta: {
        title: '项目记录',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/ProjectsPanel/ProjectsPanel.vue'),
    },
    {
      path: 'case-recommend',
      name: 'platform_case_recommend',
      meta: {
        title: '案例推荐',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/CaseRecommendPanel/CaseRecommendPanel.vue'),
    },
    {
      path: 'ai-app',
      name: 'platform_ai_app',
      meta: {
        title: 'AI应用',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/AiAppPanel/AiAppPanel.vue'),
    },
    {
      path: 'ai-app/create',
      name: 'platform_ai_app_create',
      meta: {
        title: 'AI应用制作',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/AiAppPanel/AiAppCreate.vue'),
    },
    {
      path: 'ecommerce/parse',
      name: 'platform_ecommerce_parse',
      meta: {
        title: '电商短视频复刻',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/EcommercePanel/EcommerceParsePanel.vue'),
    },
    {
      path: 'order',
      name: 'platform_order',
      meta: {
        title: '订单明细',
        auth: true,
        menu: 'platform',
        hideTaskSidebar: true
      },
      component: () => import('@/platform/pages/orderView/order.vue'),
    },
    {
      path: 'bill',
      name: 'platform_bill',
      meta: {
        title: '马力明细',
        auth: true,
        menu: 'platform',
        hideTaskSidebar: true
      },
      component: () => import('@/platform/pages/orderView/bill.vue'),
    },
    {
      path: 'transactions',
      name: 'platform_transactions',
      meta: {
        title: '流水明细',
        auth: true,
        menu: 'platform',
        hideTaskSidebar: true
      },
      component: () => import('@/platform/pages/orderView/transactions.vue'),
    },
    {
      path: 'account-setting',
      name: 'platform_account_setting',
      meta: {
        title: '账号设置',
        auth: true,
        menu: 'platform',
        hideTaskSidebar: true
      },
      component: () => import('@/platform/pages/accountSetting/accountSetting.vue'),
    },
    {
      path: 'team',
      name: 'platform_team',
      redirect: { name: 'platform_team_members' },
      meta: {
        title: '团队管理',
        auth: true,
        menu: 'platform'
      },
      component: () => import('@/platform/pages/TeamPanel/TeamPanel.vue'),
      children: [
        {
          path: 'members',
          name: 'platform_team_members',
          meta: {
            title: '团队成员',
            auth: true,
            menu: 'platform'
          },
          beforeEnter: teamPermissionGuard('members'),
          component: () => import('@/platform/pages/TeamPanel/TeamMembers.vue'),
        },
        {
          path: 'orders',
          name: 'platform_team_orders',
          meta: {
            title: '团队订单',
            auth: true,
            menu: 'platform'
          },
          beforeEnter: teamPermissionGuard('admin'),
          component: () => import('@/platform/pages/TeamPanel/TeamOrders.vue'),
        },
        {
          path: 'points',
          name: 'platform_team_points',
          meta: {
            title: '马力明细',
            auth: true,
            menu: 'platform'
          },
          beforeEnter: teamPermissionGuard('admin'),
          component: () => import('@/platform/pages/TeamPanel/TeamPoints.vue'),
        },
        {
          path: 'packages',
          name: 'platform_team_packages',
          meta: {
            title: '团队套餐',
            auth: true,
            menu: 'platform'
          },
          beforeEnter: teamPermissionGuard('admin'),
          component: () => import('@/platform/pages/TeamPanel/TeamPackages.vue'),
        },
        {
          path: 'balance',
          name: 'platform_team_balance',
          meta: {
            title: '管理员余额',
            auth: true,
            menu: 'platform'
          },
          beforeEnter: teamPermissionGuard('admin'),
          component: () => import('@/platform/pages/TeamPanel/TeamBalance.vue'),
        },
      ],
    },
    {
      path: 'brokerage',
      name: 'platform_brokerage',
      meta: {
        title: '代理佣金',
        auth: true,
        menu: 'platform'
      },
      beforeEnter: agentPermissionGuard,
      component: () => import('@/platform/pages/TeamPanel/TeamBrokerage.vue'),
    },
  ],
}]
export default platformRouter
